import { render, staticRenderFns } from "./SafetyAccidentBasicData.vue?vue&type=template&id=0732cc7a&scoped=true"
import script from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js"
import style0 from "./SafetyAccidentBasicData.vue?vue&type=style&index=0&id=0732cc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732cc7a",
  null
  
)

export default component.exports